module.exports = "<a class=\"button\" href=\"{{downloadURI}}/{{docId}}?&portalRoute={{documentNotFoundURL}}\" target=\"_blank\">\n    <span class=\"fa fa-file\"></span>\n</a>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/directives/templates/mfp-download-document.html
// module id = 607
// module chunks = 0